document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('mobileMenuToggle');
  var nav = document.getElementById('mobileNav');
  var closeBtn = document.getElementById('mobileNavClose');
  var navScroll = nav ? nav.querySelector('.mobile-nav-scroll') : null;
  var lockedScrollY = 0;

  function setNav(open) {
    if (!nav || !toggle) return;
    nav.classList.toggle('is-open', open);
    nav.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('sora-nav-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    var im = toggle.querySelector('.icon-menu');
    var ic = toggle.querySelector('.icon-close');
    if (im) im.style.display = open ? 'none' : 'block';
    if (ic) ic.style.display = open ? 'block' : 'none';

    // Verrou de scroll de la page derriere le menu (iOS Safari).
    // Le menu, lui, a son propre conteneur scrollable (.mobile-nav-scroll).
    if (open) {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = (-lockedScrollY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      if (navScroll) navScroll.scrollTop = 0;
    } else {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedScrollY);
    }
  }

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      setNav(!nav.classList.contains('is-open'));
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setNav(false); });
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function () { setNav(false); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav && nav.classList.contains('is-open')) setNav(false);
  });

  // Accordeon : un seul sous-menu ouvert a la fois
  var allToggles = document.querySelectorAll('.mobile-nav-toggle');
  allToggles.forEach(function (t) {
    var sub = document.getElementById(t.dataset.submenu);
    if (!sub) return;
    t.addEventListener('click', function () {
      var willOpen = !sub.classList.contains('is-open');
      allToggles.forEach(function (otherT) {
        var otherSub = document.getElementById(otherT.dataset.submenu);
        if (otherSub && otherSub !== sub) {
          otherSub.classList.remove('is-open');
          otherT.setAttribute('aria-expanded', 'false');
        }
      });
      sub.classList.toggle('is-open', willOpen);
      t.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      // On remonte le bouton en haut du conteneur scrollable, sans
      // toucher au scroll de la page (scrollIntoView deplacait la page).
      if (willOpen && navScroll) {
        setTimeout(function () {
          navScroll.scrollTo({ top: t.offsetTop - 8, behavior: 'smooth' });
        }, 180);
      }
    });
  });

  var els = document.querySelectorAll('.sora .reveal');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { io.observe(el); });

  var root = document.documentElement;
  var warmthEl = document.querySelector('.sora .ambient-warmth');
  var ticking = false;
  var fadeTimer = null;
  var SUN_START_PERCENT = 0.28;

  function updateSun() {
    var scrollTop = window.scrollY || root.scrollTop;
    var docHeight = (document.body.scrollHeight - window.innerHeight) || 1;
    var percent = Math.min(Math.max(scrollTop / docHeight, 0), 1);
    root.style.setProperty('--sun-y', (8 + percent * 84) + '%');
    if (warmthEl) {
      if (percent < SUN_START_PERCENT) {
        warmthEl.classList.remove('is-scrolling');
        warmthEl.classList.add('is-suppressed');
      } else {
        warmthEl.classList.remove('is-suppressed');
      }
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    var scrollTop = window.scrollY || root.scrollTop;
    var docHeight = (document.body.scrollHeight - window.innerHeight) || 1;
    var percent = Math.min(Math.max(scrollTop / docHeight, 0), 1);
    if (warmthEl && percent >= SUN_START_PERCENT) {
      warmthEl.classList.add('is-scrolling');
      if (fadeTimer) clearTimeout(fadeTimer);
      fadeTimer = setTimeout(function () {
        if (warmthEl) warmthEl.classList.remove('is-scrolling');
      }, 350);
    }
    if (!ticking) {
      window.requestAnimationFrame(updateSun);
      ticking = true;
    }
  }, { passive: true });

  updateSun();

  var precioSection = document.getElementById('precio');
  if (precioSection && warmthEl) {
    var precioObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        warmthEl.classList.toggle('sun-off', entry.isIntersecting);
      });
    }, { threshold: 0 });
    precioObserver.observe(precioSection);
  }
});
